import { HashLink } from 'react-router-hash-link'
import {
  faChartLine, faLayerGroup, faTachometer, faTasks,
} from '@fortawesome/pro-light-svg-icons'

import { TaskListModel, TaskListSectionModel } from '@models/types'

const TASK_PATH_REGEX = /projects\/[0-9]+\/tasks/

const scrollWithOffset = (el) => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset
  const yOffset = -172
  window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' })
}

const mapSections = (taskListSections: TaskListSectionModel[]) => taskListSections.map(section => ({
  icon: faLayerGroup,
  key: section.id,
  linkProps: {
    scroll: el => scrollWithOffset(el),
    smooth: true,
    to: `/projects/${section.task_list_id}/tasks#taskListSection-${section.id}`,
  },
  linkTag: HashLink,
  title: section.title,
  visible: true,
}))

const generateNavigationItems = (params: { pathname: string, taskList: TaskListModel, taskListSections: TaskListSectionModel[] }) => {
  const { pathname, taskList, taskListSections } = params

  return {
    sections: [
      {
        key: 'dashboard',
        visible: true,
        items: [
          {
            href: `#/projects/${taskList.id}/edit`,
            icon: faTachometer,
            key: 'dashboard',
            title: 'Overview',
            visible: true,
          },
          {
            href: `#/projects/${taskList.id}/tasks`,
            icon: faTasks,
            key: 'tasks',
            title: 'Tasks',
            visible: true,
          },
          {
            href: `#/projects/${taskList.id}/analytics`,
            icon: faChartLine,
            key: 'analytics',
            title: 'Analytics',
            visible: true,
          },
        ],
      },
      {
        key: 'taskListSections',
        title: 'GROUPS',
        visible: TASK_PATH_REGEX.test(pathname),
        items: mapSections(taskListSections),
      },
    ],
  }
}

export default generateNavigationItems
